@if (viewModel(); as bannerViewModel) {
  <mps-maintenance-banner [viewModel]="bannerViewModel" />
}
